import React from 'react';
import { 
  Card,
  Spin,
  Form
} from 'antd';
import { FeeDTO } from '@/shared/api/model';
import { useTheme } from '@/components/common/ThemeProvider';
import FeesPanel from './FeesPanel';
import useFees from '../hooks/useFees';

interface FeesConfigPanelProps {
  productGlNo: string;
  productName: string;
}

const FeesConfigPanel: React.FC<FeesConfigPanelProps> = ({
  productGlNo,
  productName
}) => {
  const [form] = Form.useForm();
  const { dark } = useTheme();
  
  // Initialize fees handling
  const { 
    fees, 
    glAccounts, 
    acAccounts, 
    isLoading: isLoadingFees, 
    handleFeesChange,
    saveAllFees,
    refetchFees
  } = useFees({ productGlNo });

  return (
    <div className={dark ? 'dark-mode' : ''}>
      <Card 
        title={`Fee Configuration for ${productName}`}
        extra={
          <div style={{ fontSize: '0.9em', color: '#888' }}>
            Changes to fees are saved automatically
          </div>
        }
      >
        <Spin spinning={isLoadingFees}>
          <Form
            form={form}
            layout="vertical"
          >
            <FeesPanel
              glNo={productGlNo}
              fees={fees}
              onFeesChange={handleFeesChange}
              glAccounts={glAccounts}
              acAccounts={acAccounts}
              isLoading={isLoadingFees}
              standalone={true}
              externalForm={form}
            />
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default FeesConfigPanel;
